import BaseStore from './BaseStore';
import rp from 'request-promise';
import config from '../config';
// import { notification } from 'antd'
import 'antd/dist/antd.css';
// import _ from 'lodash';
import { getToken } from '../components/Token';
import { getTenantHeaders } from '../components/TenantHeaders';
import { clearLocalStorage } from '../utils/common';

export class DeviceStore extends BaseStore {
  constructor() {
    super();
    this.observable({
      loading: false,
      devicesList: [],
      devices: [],
      offset: 0,
      limit: 15,
      search: null,
      sort: null,
      order: null,
      tenantIds: null,
      filterOutStatus: [],
      action: null,
      fixedEmergencyDevices: [],
      deviceUsageSummary: null,
      noActiveDevcies: 0,
      noCurrentlyAssignedDevcies: 0,
      noActivePatients: 0,
    });
  }
  setAction(task, data) {
    this[task] = data;
  }

  resetData() {
    this.offset = 0;
    this.limit = 15;
    this.search = null;
    this.sort = null;
    this.order = null;
    this.tenantIds = null;
    this.filterOutStatus = [];
    this.devices = [];
    this.fixedEmergencyDevices = [];
    this.deviceUsageSummary = null;
    this.noActiveDevcies = 0;
    this.noCurrentlyAssignedDevcies = 0;
    this.noActivePatients = 0;
  }

  async setData(task, data, getDevices = true) {
    this[task] = data;
    if (getDevices) {
      await this.getDevices(
        this.filterOutStatus,
        this.offset,
        this.limit,
        this.search,
        this.sort,
        this.order,
        this.tenantIds,
      );
    }
  }

  reformatUsageSummaryData(usagesummary) {
    if (usagesummary.patients && usagesummary.patients.length > 0) {
      let activeDevcies = 0;
      let activePatients = 0;
      const formatData = usagesummary.patients.map((p) => {
        // set expand, collapse
        p.toggle = false;

        // get period of days
        const periodOfDevices = [];
        p.assignedDevices.forEach((d) => {
          const days =
            -Math.ceil(
              (new Date(d.startDateOfUseDeviceInPeriod) - new Date(d.endDateOfUseDeviceInPeriod)) /
              (1000 * 60 * 60 * 24),
            ) + 1;
          periodOfDevices.push(days);
        });
        p.activeAllDays = Math.max.apply(null, periodOfDevices);

        // get no. of active devices
        const activeDevices = p.assignedDevices.filter((d) => d.countMsg);
        activeDevcies += activeDevices.length;

        // get no. of active patients
        if (p.totalCountMsg > 0) {
          activePatients += 1;
        }

        return p;
      });

      this.noActiveDevcies = activeDevcies;
      this.noActivePatients = activePatients;

      return formatData;
    }
    return [];
  }

  async getDevices(
    filterOutStatus = [],
    offset = 0,
    limit = 15,
    search = null,
    sort = null,
    order = null,
    tenantIds = null,
    noLoadtest = false,
  ) {
    this.loading = true;
    let queryOption = {};
    queryOption.filterOutStatus = filterOutStatus;
    queryOption.offset = offset;
    queryOption.limit = limit;
    if (tenantIds && tenantIds.length > 0) {
      queryOption.tenantIds = JSON.stringify(tenantIds);
    }
    if (search) {
      queryOption.search = search;
    }
    if (sort) {
      queryOption.sort = sort;
    }
    if (order) {
      queryOption.order = order;
    }
    if (noLoadtest) {
      queryOption.noLoadtest = noLoadtest;
    }
    try {
      let url = `${config.api.url}/${config.api.version}/device/cms/list`;
      const res = await rp
        .get(url, {
          qs: queryOption,
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        const devices = res.body || {};
        return (this.devices = devices);
      }
    } catch (err) {
      if (err.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      }
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async deleteDevice(id) {
    this.loading = true;
    try {
      const res = await rp
        .delete(`${config.api.url}/${config.api.version}/device/${id}`, {
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        // notification.success({
        //   message: `Delete Success`,
        //   description: `Device has been delete successfully`,
        //   top: '100px',
        // });
        // window.location.href = '/app/devices'
        return res;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async activateDevice(data) {
    this.loading = true;
    try {
      const res = await rp
        .put(`${config.api.url}/${config.api.version}/device/${data.id}`, {
          body: data,
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async updateDevice(data, subGroups = null) {
    this.loading = true;
    try {
      const detail = {
        name: data.name,
        serial: data.deviceId,
        description: data.description,
        version: data.deviceType,
        status: data.status,
        firmwareVersion: data.firmwareVersion,
        purchasedDate: data.purchasedDate,
        dateLastServiced: data.dateLastServiced,
        subgroupPermission: subGroups ? JSON.stringify(subGroups) : null,
        tenantId: data.tenantId,
        manufacturer: data.manufacturer,
      };
      if (data.category === 'EMERGENCY_BUTTON' && data.property && !data.property.localization) {
        detail.place = data.devicePlace;
      } else {
        detail.place = null;
      }
      const res = await rp
        .put(`${config.api.url}/${config.api.version}/device/${data.id}`, {
          body: detail,
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async createDevice(data, subgroupPermission = null) {
    this.loading = true;
    try {
      const detail = {
        name: data.name,
        serial: data.deviceId,
        description: data.description,
        version: data.deviceType,
        firmwareVersion: data.firmwareVersion,
        purchasedDate: data.purchasedDate,
        tenantId: data.tenantId,
        manufacturer: data.manufacturer,
      };
      if (data.category === 'EMERGENCY_BUTTON' && data.property && !data.property.localization) {
        detail.place = data.devicePlace;
      }
      if (subgroupPermission && subgroupPermission.length > 0) {
        detail.subgroupPermission = JSON.stringify(subgroupPermission);
        detail.status = 'ACTIVATE_OFF';
      }
      const res = await rp
        .post(`${config.api.url}/${config.api.version}/device`, {
          body: detail,
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async findById(id) {
    this.loading = true;
    try {
      let url = `${config.api.url}/${config.api.version}/device/${id}`;
      const res = await rp
        .get(url, {
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        const devices = res.body || {};
        return (this.devices = devices);
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async findBySerial(serialId) {
    this.loading = true;
    try {
      let url = `${config.api.url}/${config.api.version}/device/${serialId}`;
      const res = await rp
        .get(url, {
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        const devices = res.body || {};
        return (this.devices = devices);
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async findBySerials(serials) {
    try {
      let url = `${config.api.url}/${config.api.version}/device/serial`;
      const res = await rp
        .post(url, {
          body: { serials },
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        const devices = res.body || {};
        return devices;
      }
    } catch (err) {
      throw err;
    }
  }

  async assignDeviceToPatient(data) {
    this.loading = true;
    try {
      const detail = {
        device_ids: data.deviceId,
        patient_id: data.patient_id,
      };
      const res = await rp
        .post(`${config.api.url}/${config.api.version}/device/assign`, {
          body: detail,
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        console.log(res);
        return true;
      }
    } catch (err) {
      // if (err.statusCode === 401) {
      //   setTimeout(() => {
      //     removeToken('id_token')
      //     window.location.href = '/login'
      //   }, 1000)
      // }
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async unAssignDeviceToPatient(deviceId, deviceSerial) {
    this.loading = true;
    try {
      const detail = {
        device_id: deviceId,
      };
      const res = await rp
        .post(`${config.api.url}/${config.api.version}/device/unassign`, {
          body: detail,
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));

      // clear last notification
      await rp
        .delete(`${config.api.url}/${config.api.version}/notification/${deviceSerial}`, {
          body: {},
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));

      if (res && res.statusCode === 200) {
        return true;
      }
    } catch (err) {
      // if (err.statusCode === 401) {
      //   setTimeout(() => {
      //     removeToken('id_token')
      //     window.location.href = '/login'
      //   }, 1000)
      // }
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async saveDevices(devicesList, subgroupsList) {
    this.loading = true;
    try {
      const detail = {
        devices: devicesList.map((val) => val.id),
        subgroupsId: subgroupsList.map((val) => val),
      };
      const res = await rp
        .post(`${config.api.url}/${config.api.version}/device/assign/permission/subgroup/list`, {
          body: detail,
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async getDevicesBySubgroupIds(subgroupIds) {
    if (subgroupIds) {
      this.loading = true;
      try {
        const data = { subgroupIds: subgroupIds };
        let url = `${config.api.url}/${config.api.version}/device/permission/subgroup`;
        const res = await rp
          .post(url, {
            body: data,
            json: true,
            authorization: true,
            resolveWithFullResponse: true,
            headers: {
              ...getTenantHeaders(),
            },
          })
          .auth(null, null, true, getToken('id_token'));
        if (res.statusCode === 200) {
          const devicesList = res.body || {};
          return (this.devicesList = devicesList);
        }
      } catch (err) {
        if (err.statusCode === 401) {
          clearLocalStorage();
          window.location.href = '/login';
        }
        throw err;
      } finally {
        this.loading = false;
      }
    }
  }

  async updateSubgroupPermission(id, selectSubGroups) {
    this.loading = true;
    try {
      const detail = {
        subgroupPermission: selectSubGroups.map((val) => val.id),
      };
      const res = await rp
        .put(`${config.api.url}/${config.api.version}/device/permission/subgroup/${id}`, {
          body: detail,
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async getFixedEmergencyDevices(queryOption) {
    this.loading = true;
    try {
      let url = `${config.api.url}/${config.api.version}/device/fixedemergency/list`;
      const res = await rp
        .get(url, {
          qs: queryOption,
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        const devices = res.body || [];
        return (this.fixedEmergencyDevices = devices);
      }
    } catch (err) {
      if (err.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      }
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async assignDevicesToMap(data) {
    this.loading = true;
    try {
      const detail = {
        devices: data,
      };
      const res = await rp
        .post(`${config.api.url}/${config.api.version}/device/map/assign`, {
          body: detail,
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      if (err.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      }
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async getUsageSummary(startDate, endDate, tenantId) {
    this.loading = true;
    let queryOption = {};
    queryOption.tenantId = tenantId;
    queryOption.startDate = startDate;
    queryOption.endDate = endDate;
    try {
      let url = `${config.api.url}/${config.api.version}/device/usagesummary/json`;
      const res = await rp
        .get(url, {
          qs: queryOption,
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        let usagesummary = res.body || {};
        usagesummary.patients = this.reformatUsageSummaryData(usagesummary);
        this.deviceUsageSummary = usagesummary;
      }
    } catch (err) {
      if (err.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      }
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async getUsageSummaryCSV(startDate, endDate, tenantId) {
    this.loading = true;
    let queryOption = {};
    queryOption.tenantId = tenantId;
    queryOption.startDate = startDate;
    queryOption.endDate = endDate;
    try {
      let url = `${config.api.url}/${config.api.version}/device/usagesummary/csv`;
      const res = await rp
        .get(url, {
          qs: queryOption,
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        const devices = res.body || {};
        return (this.devices = devices);
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }
}

export default new DeviceStore();
